// src/components/Header.js
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar 
      position="fixed"
      sx={{ 
        backgroundColor: 'white', 
        boxShadow: 'none', 
        height: '5rem', 
        borderBottom: '1px solid rgb(139,206,252)',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Logo a la izquierda */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src={process.env.PUBLIC_URL + '/Logo definitivo DC-02.png'} 
              alt="Logo" 
              style={{ maxWidth: '10rem', marginRight: '1rem' }}
            />
          </Box>

          {/* Botones para pantallas medianas en adelante */}
          <Box 
            sx={{ 
              display: { xs: 'none', md: 'flex' },
              gap: 2  // Espacio entre botones
            }}
          >
            <Button 
              component="a" 
              href="#who-we-are" 
              sx={{ 
                color: 'black',
                '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' }
              }}
            >
              Who We Are
            </Button>
            <Button 
              component="a" 
              href="#success-stories" 
              sx={{ 
                color: 'black',
                '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' }
              }}
            >
              Success Stories
            </Button>
            <Button 
              component="a" 
              href="#how-we-work" 
              sx={{ 
                color: 'black',
                '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' }
              }}
            >
              How We Work
            </Button>
            <Button 
              component="a" 
              href="#marketing" 
              sx={{ 
                color: 'black',
                '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' }
              }}
            >
              Marketing
            </Button>
          </Box>

          {/* Menú hamburguesa para móviles */}
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton edge="end" onClick={handleMenuOpen}>
              <MenuIcon sx={{ color: 'black' }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem 
                onClick={handleMenuClose} 
                component="a" 
                href="#who-we-are"
                sx={{ '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' } }}
              >
                Who We Are
              </MenuItem>
              <MenuItem 
                onClick={handleMenuClose} 
                component="a" 
                href="#success-stories"
                sx={{ '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' } }}
              >
                Success Stories
              </MenuItem>
              <MenuItem 
                onClick={handleMenuClose} 
                component="a" 
                href="#how-we-work"
                sx={{ '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' } }}
              >
                How We Work
              </MenuItem>
              <MenuItem 
                onClick={handleMenuClose} 
                component="a" 
                href="#marketing"
                sx={{ '&:hover': { backgroundColor: 'rgb(139,206,252, 0.45)' } }}
              >
                Marketing
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
